import axios from 'axios'
import qs from 'qs'
import { RIGHTS_CHECKOUT_AS_CLIENT } from '../../constants/rights'
import constants from '@/helpers/constants'
import { isEqual } from '@/helpers/isEqual'
import { EsputnikService } from '@/services/AnalyticService'

export default {
  state: {
    auth: null,
    user_data: null,
    hasWelcomeBonus: false,
    isContactFormLoading: false,
    userType: window?.config?.['logged_in_as'] ?? constants.USER_TYPE.CUSTOMER,
    managerType: window?.config?.['manager_type'] ?? null
  },
  getters: {
    isAuth: (state) => {
      return state.auth
    },
    userName: (state) => {
      if (state?.['user_data']?.['name']) return state['user_data']['name']
      return ''
    },
    isCheckoutAsClient: () => {
      return window?.userRights?.[RIGHTS_CHECKOUT_AS_CLIENT]
    },
    isManager: ({ userType }) => {
      return userType === constants.USER_TYPE.MANAGER
    },
    canManagerSelectCity ({ managerType, isManager }) {
      return (managerType === constants.MANAGER_TYPE.SELLER_FM_MANAGER || managerType === constants.MANAGER_TYPE.FRANCH_SALE_MANAGER)
    }
  },
  mutations: {
    SET_USER_DATA: (state, user) => {
      state.auth = user.auth
      state.user_data = user.user_data
    },
    UPDATE_USER_DATA: (state, user) => {
      state.user_data = { ...state.user_data, ...user }
    },
    SET_CONTACT_FORM_LOADING: (state, data) => {
      state.isContactFormLoading = data
    },
    UPDATE_SUBSCRIBE_STATUS: (state) => {
      state.user_data.subscriber.unsubscribed = +!state.user_data.subscriber.unsubscribed
    },
    UPDATE_USER_EMAIL: (state, data) => {
      state.user_data.email = data
    },
    SET_USER_TYPE: (state, type) => {
      state.userType = type
    },
    SET_MANAGER_TYPE: (state, type) => {
      state.managerType = type
    },
    SET_WELCOME_BONUS_STATUS: (state, bool) => {
      state.hasWelcomeBonus = bool
    }
  },
  actions: {
    FETCH_USER_DATA: ({ commit, rootGetters, rootState, dispatch, state }, params) => {
      const isCheckout = constants.IS_CHECKOUT()

      commit('SET_CONTACT_FORM_LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/auth/auth/user-info/', {
            params: {
              user_data: params.fields
            }
          })
          .then(response => {
            commit('SET_USER_DATA', response.data)

            if (!response.data.auth) localStorage.setItem('formData', null)

            if (isCheckout && response.data.auth) {
              dispatch('FETCH_LEGAL_PERSON_INFO')
              // dispatch('FETCH_CART_BONUSES_INFO')
            }
            if (rootGetters.currentSessionHash !== localStorage.getItem('sessionId') && response.data.auth && state.selectedUserGeo && response.data.user_city_location && response.data.user_city_location.city_id !== state.selectedUserGeo.city_id) {
              localStorage.setItem('sessionId', rootGetters.currentSessionHash)
              if (!localStorage.getItem('userGeo')) {
                commit('SET_POTENTIAL_USER_CITY', response.data.user_city_location)
                commit('SET_IS_GEO_POPUP_SHOWN', true)
              } else {
                const geoGPS = JSON.parse(localStorage.getItem('userGeo'))
                const { latitude, longitude } = geoGPS
                axios.get(rootGetters.urlLanguagePrefix + '/location/', { params: { latitude, longitude } })
                  .then(res => {
                    if (res.data.city_list && res.data.city_list.length) {
                      commit('SET_POTENTIAL_USER_CITY', res.data.city_list[0])
                      commit('SET_IS_GEO_POPUP_SHOWN', true)
                    }
                  })
              }
            }

            if (response?.data?.auth) {
              const userData = JSON.parse(JSON.stringify(response.data.user_data))
              const parsedDataFromLocalStorage = JSON.parse(localStorage.getItem(constants.USER_DATA_KEY) ?? null) ?? {}
              const isEqualData = isEqual(parsedDataFromLocalStorage, userData)

              if (!isEqualData) {
                localStorage.setItem(constants.USER_DATA_KEY, JSON.stringify(userData))

                EsputnikService.sendCustomerDataInfo({
                  userData: userData,
                  selectedUserLocation: rootState.geoLocation.selectedUserLocation
                })
              }
            }

            resolve(response.data)
          })
          .catch(error => reject(error))
          .finally(() => {
            commit('SET_CONTACT_FORM_LOADING', false)
          })
      })
    },
    CHANGE_SUBSCRIBE_NEWSLETTER_STATUS: async ({ rootGetters, commit }, payload) => {
      const { data } = await axios({
        method: 'post',
        url: rootGetters.urlLanguagePrefix + '/cabinet/profile/subscribe-or-unsubscribe/',
        data: qs.stringify(payload)
      })

      return data
    },
    SET_HIDE_CLOSEST_BTN_ACTION ({ commit }) {
      commit('SET_HIDE_CLOSEST_BTN')
    },
    CHANGE_USER_TYPE: ({ rootGetters, commit }, role) => {
      return new Promise((resolve, reject) => {
        const params = {
          type: role
        }

        axios.post(rootGetters.urlLanguagePrefix + '/set-login-as/', params)
          .then(res => {
            if (res.data?.status === 'success') {
              window.config.logged_in_as = res.data.logged_in_as
              commit('SET_USER_TYPE', res.data.logged_in_as)
            }
            resolve(res)
          })
          .catch(err => reject(err))
      })
    },
    CHANGE_MANAGER_TYPE: ({ commit }, type) => {
      commit('SET_MANAGER_TYPE', type)
    },
    CHANGE_WELCOME_BONUS_STATUS: ({ commit }, bool) => {
      commit('SET_WELCOME_BONUS_STATUS', bool)
    }
  }
}
